<template>
    <v-row dense>
        <v-col cols="12">
            <div class="FieldHelpWrap">
                <div class="FieldHelpWrap__input">
                    <ValidationProvider
                        rules="max:255"
                        v-slot="{ errors }"
                    >
                        <v-text-field
                            v-model="address1"
                            label="Street Address"
                            outlined
                            :error-messages="errors"
                            @change="setFieldData"
                        />
                    </ValidationProvider>
                </div>
                <div
                    class="FieldHelpWrap__help"
                    v-if="helpText"
                >
                    <HelpModal
                        v-if="helpText"
                        :text="helpText"
                        :title="helpTitle"
                    />
                </div>
            </div>
        </v-col>

        <v-col cols="12">
            <ValidationProvider
                rules="max:255"
                v-slot="{ errors }"
            >
                <v-text-field
                    v-model="address2"
                    label="Address 2"
                    outlined
                    :error-messages="errors"
                    @change="setFieldData"
                />
            </ValidationProvider>
        </v-col>

        <v-col
            cols="12"
            sm="4"
        >
            <ValidationProvider
                rules="max:255"
                v-slot="{ errors }"
            >
                <v-text-field
                    v-model="city"
                    label="City"
                    outlined
                    :error-messages="errors"
                    @change="setFieldData"
                />
            </ValidationProvider>
        </v-col>

        <v-col
            cols="12"
            sm="4"
        >
            <ValidationProvider
                rules="max:255"
                v-slot="{ errors }"
            >
                <v-text-field
                    v-model="state"
                    label="State"
                    outlined
                    :error-messages="errors"
                    @change="setFieldData"
                />
            </ValidationProvider>
        </v-col>

        <v-col
            cols="12"
            sm="4"
        >
            <ValidationProvider
                rules="max:255"
                v-slot="{ errors }"
            >
                <v-text-field
                    v-model="zip"
                    label="Zip Code"
                    outlined
                    :error-messages="errors"
                    @change="setFieldData"
                />
            </ValidationProvider>
        </v-col>
    </v-row>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';

export default {
    mixins: [ SubmissionBoilerplate ],

    data() {
        return {
            text: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: ''
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission) {
                this.address1 = this.submission.address1;
                this.address2 = this.submission.address2;
                this.city = this.submission.city;
                this.state = this.submission.state;
                this.zip = this.submission.zip;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                address1: this.address1,
                address2: this.address2,
                city: this.city,
                state: this.state,
                zip: this.zip,
            };

            this.storeFieldData();
        },
    }
};
</script>
